import styled, { keyframes } from 'styled-components'
import { fadeIn } from 'react-animations'

import { colors } from '../../../module/colors'
import {
  size_2,
  size_4,
  size_6,
  text_xl,
  text_md,
  text_thin,
  displayText,
} from '../../../module/style-variables'

const fadeInAnimation = keyframes`${fadeIn}`
const revealAnswerAnimation = keyframes`${fadeIn}`

export const WorkoutQuestionContainer = styled.div``

export const WorkoutTitle = styled.h1`
  ${text_xl};
  ${text_thin};
  color: ${colors.copy};
  padding: ${size_4};
  animation: ${props =>
    props.fadeInQuestion ? `${props.fadeInQuestionDuration} ${fadeInAnimation}` : ``};
`

export const WorkoutQuestion = styled.p`
  color: ${colors.copyDark};
  padding: ${size_4} ${size_2} ${size_4} ${size_2};
  ${displayText};
  ${text_md};
  animation: ${props =>
    props.fadeInQuestion ? `${props.fadeInQuestionDuration} ${fadeInAnimation}` : ``};
`

export const WorkoutAnswer = styled.p`
  color: ${colors.copy};
  padding: ${size_4} ${size_2} ${size_6} ${size_2};
  ${displayText};
  ${text_md};
  animation: ${props => `0.8s ${revealAnswerAnimation}`};
`

export const AssessmentBarContainer = styled.div`
  padding: ${size_2} 0 ${size_6} 0;
`

export const NextButtonContainer = styled.div`
  padding-top: ${size_2};
`

export const RevealButtonContainer = styled.div`
  padding-top: ${size_2};
  padding-bottom: ${size_4};
`



// WEBPACK FOOTER //
// ./src/component/_presentational/WorkoutQuestion/WorkoutQuestion-styled.js